import axios from "axios";

class CandidateShareWFServices {
    getRejectedHistory = (queryParams) => { 
        return axios.get(`api/workflow/history?$filter=${queryParams}`)
    };
}

export default new CandidateShareWFServices();